import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  IconButton,
  Typography
} from '@mui/material';
import Box from '@mui/material/Box';
import React from 'react';
import {
  Column,
  SimpleTable
} from '../../../../components/SimpleTable';
import {SupportPlanTask} from '../../../../model/support/task/support-plan-task';
import {SearchableOrder} from '../../../../state/searchable-state';
import {FormatUtils} from '../../../../utils/format.utils';

type Props = {
  tasks: SupportPlanTask[]
  translate: (key: string) => string
  translateLocal: (key: string) => string // support.plan.task
  onTaskPressed: (task: SupportPlanTask) => void
  ordering: SearchableOrder[];
  onOrdering: (ordering: SearchableOrder) => void;
}

export const SupportTaskTable = ({tasks, onTaskPressed, ordering, onOrdering, translate, translateLocal}: Props) => {
  const formatTimeColumn = (row: SupportPlanTask) => {
    if(row.startTime && row.endTime) {
      return `${row.startTime} - ${row.endTime}`
    }
    return ''
  }

  const columns: Column<SupportPlanTask>[] = [
    { key: 'id', orderKey: 'support_plan_task.id', label: translateLocal('column.id'), render: (row) => {
        return <Box key={row.id} display="flex" alignItems="center" gap={0.5}>
          <IconButton onClick={() => onTaskPressed(row)} aria-label={translate('common.details.title')}>
            <InfoOutlinedIcon />
          </IconButton>
          <Typography variant="body2">{row.id}</Typography>
        </Box>
      } },
    { key: 'ticketName', label: translateLocal('column.ticketName'), render: (row) => row.ticketName },
    { key: 'type', orderKey: 'support_plan_task.task_type', label: translateLocal('column.type'), render: (row) => translateLocal(`type.${row.taskType}`) },
    { key: 'title', orderKey: 'support_plan_task.title', label: translateLocal('column.title'), render: (row) => row.title },

    { key: 'startDate', orderKey: 'support_plan_task.start_date', label: translateLocal('column.startDate'), render: (row) => FormatUtils.formatDate(row.startDate) },
    { key: 'endDate', orderKey: 'support_plan_task.end_date', label: translateLocal('column.endDate'), render: (row) => FormatUtils.formatDate(row.endDate) },
    { key: 'time', label: translateLocal('column.time'), render: (row) => formatTimeColumn(row) },
    { key: 'plannedHours', orderKey: 'support_plan_task.planned_hours', label: translateLocal('column.plannedHours'), render: (row) => row.plannedHours },
    { key: 'meetingLink', label: translateLocal('column.meetingLink'), render: (row) => row.meetingLink ?? '-' },
    { key: 'createDate', orderKey: 'support_plan_task.created_date_timestamp', label: translateLocal('column.createDate'), render: (row) => FormatUtils.formatDate(row.createDate) },
  ]

  return <SimpleTable
    rows={tasks}
    columns={columns}
    rowKey={(row) => row.id}
    ordering={ordering}
    onOrdering={onOrdering}
  />
}